import { render, staticRenderFns } from "./SupplementaryIconOld.vue?vue&type=template&id=16c6daca&scoped=true"
import script from "./SupplementaryIconOld.vue?vue&type=script&lang=js"
export * from "./SupplementaryIconOld.vue?vue&type=script&lang=js"
import style0 from "./SupplementaryIconOld.vue?vue&type=style&index=0&id=16c6daca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c6daca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c6daca')) {
      api.createRecord('16c6daca', component.options)
    } else {
      api.reload('16c6daca', component.options)
    }
    module.hot.accept("./SupplementaryIconOld.vue?vue&type=template&id=16c6daca&scoped=true", function () {
      api.rerender('16c6daca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/SupplementaryIconOld.vue"
export default component.exports